import { render, staticRenderFns } from "./previewQuestions.vue?vue&type=template&id=5f823a8e&scoped=true"
import script from "./previewQuestions.vue?vue&type=script&lang=js"
export * from "./previewQuestions.vue?vue&type=script&lang=js"
import style0 from "./previewQuestions.vue?vue&type=style&index=0&id=5f823a8e&prod&scoped=true&lang=css"
import style1 from "./previewQuestions.vue?vue&type=style&index=1&id=5f823a8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f823a8e",
  null
  
)

export default component.exports